import {Parser} from "expr-eval";

const betterParser = new Parser()

betterParser.functions.SUMA = function (factors) {
    let result = 0;
    factors.forEach(item => {
        result += item
    })
    return result
}

export {betterParser}
